import { Badge } from "@mui/material";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { Message } from "../../assets/icons";
import { useUnreadMessageCount } from "../../hooks/useUnreadMessageCount";
import pages from "../../utils/pages";
import styles from "./MessageButton.module.scss";

const MessageButton = () => {
  const unreadCount = useSelector(state => state.notification.unreadCount);

  useUnreadMessageCount();

  return (
    <NavLink to={pages.MESSAGES.PATH} className={styles.messageLink} activeClassName={styles.selected}>
      <Badge badgeContent={unreadCount} max={99} overlap="circular" classes={{ badge: styles.badge }}>
        <Message size={35} customCssClass={styles.icon} />
      </Badge>
    </NavLink>
  );
};

export default MessageButton;
